export default __webpack_public_path__ + "static/media/error.d558f893.svg";